module.exports = __webpack_public_path__ + "static/media/Scrum.3579eecb.png";